<template>
    <div class="wrapper" @mouseover='reveal = true' @mouseleave='reveal = false'>
        <div class='reference'>

            <!-- Left Navigation -->
            <div class='arrows clickable' v-show='(reveal || mobile_manager.mobile_view) && hasManyMedia && !mobile_manager.grid_view' @click.stop='loopIndex(show - 1)'> -->
                <img src='/images/arrow_large_white.svg'>
            </div>

            <!-- Image -->
            <div v-for='(m, index) in media' @click.stop='viewEnlargedOrOpenSummaryOrOpenRelations(m, index)'>
                <img :style="{'max-width': m.type == 'svg' ? width + 'px' : '100%'}"
                    :class="{
                        'full-width': m.type == 'svg',
                        'zoom-cursor': !m.is_folder && !mobile_manager.grid_view,
                        'clickable': m.is_folder || mobile_manager.grid_view
                    }"
                    :src="m.thumbnail_path"
                    v-show='index == show'
                    class='thumbnails image'
                    :title='m.title'>
            </div>

            <!-- Right Navigation -->
            <div class='arrows arrow-right clickable' v-show='(reveal || mobile_manager.mobile_view) && hasManyMedia && !mobile_manager.grid_view' @click.stop='loopIndex(show + 1)'> -->
                <img class='rotate180' src='/images/arrow_large_white.svg'>
            </div>

            <!-- Title -->
            <div class='img-nav title' v-show='object.searchable.title && (reveal || mobile_manager.mobile_view) && mobile_manager.grid_view'>
                <span>{{truncate(object.searchable.title[0], 25)}}</span>
            </div>
        </div>

        <!-- Index Navigation -->
        <div class='index' v-show='hasManyMedia'>
            <span>{{show + 1}} / {{media.length}}</span>
        </div>

    </div>
</template>

<script>
    import EventHub from './eventHub.js'
    import MobileManager from './mobileManager.js'
    import ViewRelated from '../mixins/viewRelated.js'
    import MediaParser from '../mixins/mediaParser.js'
    import ManageProperties from '../mixins/manageProperties.js'
    import ManageRelations from '../mixins/manageRelations.js'
    import Media from '../mixins/Media.js'

    export default {
        props: ['object', 'width', 'height'],
        mixins: [MediaParser, ManageProperties, ViewRelated, ManageRelations],
        created: function () {
            var self = this
            // When the component is first mounted fetch search data
            this.$nextTick(function () {
                self.media = self.parseMedia(self.object, self.width, self.height)
                self.media = self.addFolderImage(self.object, self.media, self.width, self.height)
                self.media = self.addNoImage(self.object, self.media, self.width, self.height)

                if (self.media.length < 2) {
                    self.hasManyMedia = false
                }
            })
        },
        data: function () {
            return {
                show: 0,
                reveal: false,
                hasManyMedia: true,
                mobile_manager: MobileManager,
                media: []
            }
        },
        methods: {
            loopIndex: function (index) {
                if (index < 0) {
                    this.show = this.media.length - 1
                    return
                }

                if (index >= this.media.length) {
                    this.show = 0
                    return
                }

                this.show = index
            },
            viewEnlargedOrOpenSummaryOrOpenRelations: function (media, index) {
                // If no image return
                if (!media.is_folder && this.object.images.length == 0 && this.object.media.length == 0){
                    return
                }

                // If folder and not in grid_view then click will open closest relation
                if (media.is_folder && !this.mobile_manager.grid_view) {
                    var indices = this.closestChildIndex(this.object)

                    if (indices) {
                        this.viewRelated({'indices': indices, 'parent-keyword': this.object._id}, true)
                    } else {
                        this.viewRelated({'parent-keyword': this.object._id}, true)
                    }
                    return
                }

                // If in grid view open summary
                if (this.mobile_manager.grid_view) {
                    EventHub.$emit('open-summaries', this.object)
                    return
                }

                // If in grid view open summary
                var non_viewable = _.filter(this.media, {non_viewable: true})
                var selected = index - non_viewable.length
                EventHub.$emit('view-enlarged', {object: this.object, selected: selected})
            }
        }
    }
</script>

<style lang='scss' scoped>
    @import '../../sass/variables.scss';
    .wrapper {
        font-size: 0;
        text-align: center;
        position: relative;
    }

    .reference {
        width: 100%;
        margin-top: 10px;
        overflow: hidden;
        white-space: nowrap;
        position: relative;
    }

    .arrows {
        position: absolute;
        transform: translateY(-50%);
        top: 50%;
        padding-right: 10px;
        padding-left: 10px;
        padding-top: 50px;
        padding-bottom: 50px;
    }

    .arrow-right {
        right: 0;
    }

    .image {
        padding: 5px;
        display: inline;
    }

    .full-width {
        width: 100%;
    }

    .index {
        padding: 3px;
        font-size: 7pt;
    }

    .title {
        margin-top: -19px;
        background: $dark_gray;
        min-width: 100%;
        color: white;
        padding: 3px;
        position: absolute;
        font-size: 7pt;
    }

</style>
